<template>
  <div class="contentbox">
    <!-- <div class="logo">
        <img src="/static/img/logo21.png" alt="" @click="$router.push('/')">
    </div> -->
    <!-- <div class="chgbox">
      <ul>
        <li>
          <button @click="isSelect=0;seltype='gr'" :class="isSelect==0?'chgbtn active':'chgbtn'" >培训信息查询</button> 
        </li>
        <li>
          <button @click="isSelect=1;seltype='gr'"   :class="isSelect==1?'chgbtn active':'chgbtn'" >荣誉信息查询</button>  
        </li>
      </ul>
    </div> -->
    <div class="inqBox">
      <h1><span v-if="isSelect==0">培训信息查询</span><span v-else-if="isSelect==1">企业信息查询</span><span v-else-if="isSelect==2">课题信息查询</span> </h1>
        <div class="allbox">
          <div class="leftBox" v-show="isSelect==0">
            <p style="margin-top:14px">类别</p>
            <el-select class="intype" v-model="cert.certtypename" placeholder="类别" @change="certtypechage">
              <el-option
                v-for="(certType,index) in arrCertTypes"
                :key="index"
                :label="certType.name"
                :value="certType.name">
              </el-option>
            </el-select>
            <div v-show="seltype=='gr'">
              <p>姓名</p>
              <input type="text" v-model="cert.name" class="inname" placeholder="姓名"/>
              <p>身份证号</p>
              <input type="text" v-model="cert.cardid" class="inid" placeholder="身份证号"/>
              <p>证书编号</p>
              <input type="text" v-model="cert.code" class="incert" placeholder="证书编号"/>
            </div>
            <div v-show="seltype=='qy'">
              <p>企业名称</p>
              <input type="text" v-model="cert.qiyename" class="inname" placeholder="企业名称"/>
              <p>统一社会信用代码</p>
              <input type="text" v-model="cert.socialcreditcode" class="inid" placeholder="统一社会信用代码"/>
              <p>签发编号</p>
              <input type="text" v-model="cert.code" class="incert" placeholder="签发编号"/>
            </div>
            <button @click="submitForm() ">查询</button>
            <a :href="gourl" class="certexp" style="margin-right:20px"><img src="/static/img/cert.png" alt="" /> 证书说明</a>
            <a href="https://www.cnks.org.cn/kscx"  class="certexp">查询考培证明</a>
          </div>
          <div class="leftBox" v-show="isSelect==1">
            <p style="margin-top:14px">类别</p>
            <el-select class="intype" v-model="cert.certtypename" placeholder="类别" @change="certtypechage">
              <el-option
                v-for="(certType,index) in arrRongyTypes"
                :key="index"
                :label="certType.name"
                :value="certType.name">
              </el-option>
            </el-select>
            <div v-show="seltype=='gr'">
              <p>姓名</p>
              <input type="text" v-model="cert.name" class="inname" placeholder="姓名"/>
              <p>证书编号</p>
              <input type="text" v-model="cert.code" class="incert" placeholder="证书编号"/>
            </div>
            <div v-show="seltype=='qy'">
              <p>企业名称</p>
              <input type="text" v-model="cert.qiyename" class="inname" placeholder="企业名称"/>
              <p>统一社会信用代码</p>
              <input type="text" v-model="cert.socialcreditcode" class="inid" placeholder="统一社会信用代码"/>
              <p>签发编号</p>
              <input type="text" v-model="cert.code" class="incert" placeholder="签发编号"/>
            </div>
            <button @click="submitForm() ">查询</button>
            <a :href="gourl" class="certexp" style="margin-right:20px"><img src="/static/img/cert.png" alt="" /> 证书说明</a>
            <a href="https://www.cnks.org.cn/kscx"  class="certexp">查询考培证明</a>
          </div>
          <div class="leftBox" v-show="isSelect==2">
            <p style="margin-top:14px">类别</p>
            <el-select class="intype" v-model="cert.certtypename" placeholder="类别" @change="certtypechage">
              <el-option
                v-for="(certType,index) in arrKetiTypes"
                :key="index"
                :label="certType.name"
                :value="certType.name">
              </el-option>
            </el-select>
            <div>
              <p>课题名称</p>
              <input type="text" v-model="cert.name" class="inname" placeholder="课题名称"/>
              <p>课题编码</p>
              <input type="text" v-model="cert.code" class="incert" placeholder="课题编码"/>
            </div>
            <button @click="submitForm() ">查询</button>
            <!-- <a :href="gourl" class="certexp" style="margin-right:20px"><img src="/static/img/cert.png" alt="" /> 证书说明</a>
            <a href="https://www.cnks.org.cn/kscx"  class="certexp">查询考培证明</a> -->
          </div>
        </div>
        
    </div>
    <div class="expBox">
            <div class="textBox">
              <h2>查询条件</h2>
              <p v-show="seltype=='gr'">
                1、点击证书类别，选择持有证书同类别项目名称点击确认；<br/>
                2、输入：人名+身份证号+证书编号点击查询；<br/>
                3、输入：人名+证书编号点击查询；<br/>
                4、输入：身份证号+证书编号点击查询；<br/>
                5、证书编码中若有英文字母全部需用大写字母填写；<br/>
                6、身份证号中若有英文字母全部需用大写字母填写。<br/>
              </p>
              <p v-show="seltype=='qy'">
                1、点击证书类别，选择持有证书同类别项目名称点击确认；<br/>
                2、输入：企业名称+统一社会信用代码+签发编号点击查询；<br/>
                3、输入：企业名称+签发编号点击查询；<br/>
                4、输入：统一社会信用代码+签发编号点击查询；<br/>
                5、签发编号中若有英文字母全部需用大写字母填写；<br/>
                6、统一社会信用代码中若有英文字母全部需用大写字母填写。<br/>
              </p>
            </div>
          </div>
    <el-dialog title="请选择荣誉名称" width="90%" :visible.sync="qyoccupationFlag">
        <el-form >
          <el-form-item label="荣誉名称">
            <el-select v-model="selcertname" placeholder="请选择荣誉名称">
              <el-option v-for="(cet,index) in occupations" :key="index" :label="cet.certname" :value="cet.certname">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="occupationFlag = false">取 消</el-button>
          <el-button type="primary" @click="qyhandleInq()">确 定</el-button>
        </div>
      </el-dialog>
    <el-dialog title="请选择职业名称" width="90%" :visible.sync="occupationFlag">
        <el-form >
          <el-form-item label="职业名称">
            <el-select v-model="selcertname" placeholder="请选择职业名称">
              <el-option v-for="(cet,index) in occupations" :key="index" :label="cet.certname" :value="cet.certname">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="occupationFlag = false">取 消</el-button>
          <el-button type="primary" @click="handleInq()">确 定</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>

import { certificateGR ,certificateQY,getPersonalMember } from '@/request/index';
import { getCertTypes,getFindPage } from '@/request/get';
const rate = window.innerWidth / 375;
export default {
  metaInfo: {
    title: '信息查询',
    meta: [
      {
        name: 'viewport', content:
        `width=device-width, initial-scale=${rate}, maximum-scale=1.0, user-scalable=0,minimal-ui:ios`
      }
    ]
  },
  name: "inquery",
  components: {
  },
  data() {
    return {
      occupations: [],
      occupationFlag:false,
      qyoccupationFlag:false,
      seltype:"gr",
      cert: {
        name: "",
        code:"",
        cardid:"",
        certtypename:""
      },
      selcertname:"",
      gourl:"",
      arrCertTypes:[],
      arrRongyTypes:[],
      arrKetiTypes:[],
      isSelect:0
    }
  },
  created(){
   this.getCertTypes();
   this.getFindPage();
   if(this.$route.query.inqtype=='ry')
   {
    this.isSelect=1;
   }else if(this.$route.query.inqtype=='kt')
   {
    this.isSelect=2;
   }else{
    this.isSelect=0;
   }


  },
  computed:{
    logopic() {
      return this.$store.getters.logopic;
    }
  },
  watch:{
    isSelect(){
      this.cert.certtypename = "";
    }
  },
  mounted() {
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function (event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  },
  methods: {
    certtypechage(newval) {
      if(newval=="企业荣誉"||newval=="企业证书"){
        this.seltype='qy'
      }else{
        this.seltype='gr'
      }
    },
    async getFindPage() {
      let result = await getFindPage();
      result = result.data || [];
      this.$store.dispatch("SET_PLATES", result)
      let { plates } = this.$store.state;
    let list = plates.filter((item) => '证书说明' == item.name);
    let uuid = list[0].uuid;
    this.gourl = `/news/info/${uuid}/000000`
    },
    goHome() {
      this.$router.push("/");
    },
    handleInq() {
      if (!this.selcertname) {
        this.$message.error("请选择职业名称");
        return;
      }
      for(let i=0;i<this.occupations.length;i++)
      { 
        if(this.occupations[i].certname==this.selcertname)
        {
          this.cert = this.occupations[i];
          break;
        }
      }
      this.$router.push({
        name: "Show",
        query: {
          name: this.cert.name,
          code: this.cert.code,
          certtypename: this.cert.certtypename
        }
      })
    },
    qyhandleInq() {
      if (!this.selcertname) {
        this.$message.error("请选择证书名称");
        return;
      }
      for(let i=0;i<this.occupations.length;i++)
      { 
        if(this.occupations[i].certname==this.selcertname)
        {
          this.cert = this.occupations[i];
          break;
        }
      }
      this.$router.push({
        name: "Show",
        query: {
          name: this.cert.qiyename,
          code: this.cert.code,
          certtypename: this.cert.certtypename,
          type:'qy'
        }
      })
    },
    async getCertTypes(){
      let result = await getCertTypes();
      for(let i=0;i<result.data.length;i++) {
        if(result.data[i].type=='企业')
        {
          this.arrRongyTypes.push(result.data[i])
        }else if(result.data[i].type=='课题')
        {
          this.arrKetiTypes.push(result.data[i])
        }else{
          this.arrCertTypes.push(result.data[i])
        }
      }
    },
    /**
     *  cname: "单位名称"或姓名,
        ccode: "信用代码"或证件号,
        bzcode: "证书编号"或标准号
    */
    async submitForm() {
      if(!this.cert.certtypename)
      {
        this.$message.error("请选择证书类别");
        return;
      }
      if(this.seltype=='qy')
      {
         let isry = '0';
        if(this.cert.certtypename.indexOf("荣誉")>-1)
        {
          isry = '1'
        }
        if ((this.qiyename == "" && this.code == "")
          || (this.qiyename == "" && this.socialcreditcode == "")
          || (this.code == "" && this.socialcreditcode == "")) {
          return;
        }
        let result =await certificateQY(this.cert.certtypename,this.cert.code,this.cert.qiyename,this.cert.socialcreditcode);
        if(result.data.length==1)
        {
          this.cert = result.data[0];
          this.$router.push({
            name: "Show",
            query: {
              name: this.cert.qiyename,
              code: this.cert.code,
              certtypename: this.cert.certtypename,
              type:'qy',
              isry
            }
          })
        }else if(result.data.length>1)
        {
          this.occupations = result.data || [];
          this.occupationFlag = true;
        }
      }else{
      if ((this.name == "" && this.code == "")
        || (this.name == "" && this.cardid == "")
        || (this.code == "" && this.cardid == "")) {
        return;
      }
        if(this.cert.certtypename.indexOf("荣誉")>-1)
        {
          if ((this.cert.name == "" && this.cert.code == "")) {
            return;
          }
          let result =await getPersonalMember(this.cert.name,this.cert.code);
          if(result.data.length>0)
          {
            this.$router.push({
              name: "MemberRlt",
              query: {
                name: this.cert.name,
                code: this.cert.code,
                inqType:"gr"
              }
            })
          }else{
            this.$message.error("您输入的信息不存在，谨防假冒。");
          }
          return
        }
      let result =await certificateGR(this.cert.certtypename,this.cert.code,this.cert.name,this.cert.cardid);
      if(result.data.length==1)
      {
        this.cert = result.data[0];
        this.$router.push({
          name: "Show",
          query: {
            name: this.cert.name,
            code: this.cert.code,
            certtypename: this.cert.certtypename,
            inqType:this.isSelect
          }
        })
      }else if(result.data.length>1)
      {
        this.occupations = result.data || [];
        this.occupationFlag = true;
      }
    }
    }
  }
};
</script>
<style scoped >

.logo{
    text-align: center;
    position: relative;
    top: 12px;
}
.logo img{
  width: 344px;
}
.contentbox{
    /* height: 100%; */
    background-color: #0157C6;
    background-image:url(/static/img/inq_m.png);
    background-size: contain;
    background-repeat: no-repeat;
    padding-bottom: 50px;
}
.inqBox{
    position: relative;
    top: 42px;
    width: 280px;
    height: 402px;
    background: rgba(255,255,255,0.2);
    /* background-image: url(/static/img/info_bg.png); */
    border-radius: 8px;
    margin: auto;
    padding: 32px;
    padding-top:14px;
    text-align: center;
    backdrop-filter: blur(1px);
}
.inqBox h1{
    font-size: 18px;
    /* font-weight: bold; */
    color: #FFFFFF;
    line-height: 23px;
    text-align: center;
    letter-spacing: 3px;
}
.leftBox p{
  margin-top:15px ;
  text-align: left;
  color: #FFFFFF;
  font-size:16px;
}
.leftBox input {
    width: 258px;
    height: 16px;
    margin-top:5px ;
    background:rgba(255,255,255,0.4);
    background-repeat: no-repeat;
    background-position: 9px 13px;
    border-radius: 8px 8px 8px 8px;
    font-size: 16px;
    color: #FFFFFF;
    padding: 12px 10px 12px 12px;
}
.leftBox .intype{
    width: 258px;
    height: 40px;
    margin-top:5px ;
    background: rgba(255,255,255,0.4);
    background-repeat: no-repeat;
    background-position: 9px 13px;
    border-radius: 8px 8px 8px 8px;
    color: #fff;
    font-size: 16px;
    padding: 0px 10px 0px 12px;
}

.leftBox button {
  width: 280px;
  height: 40px;
  margin-top: 25px;
  background: #0157C6;
  border-radius: 8px 8px 8px 8px;
  font-size: 16px;
  letter-spacing: 5px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 28px;
}
.allbox{
  height: 369px;
}
.leftBox{
  height: 369px;
 
  display: inline-block;
}
.intype >>>.el-input__inner{
  background-color:transparent;
  border:none;
  height: 46px;
    line-height: 46px;
    padding:0px;
    font-size: 16px;
}
.intype>>>.el-input__inner{
  color: #fff;
  /* font-size: 14px; */
}
.certexp{
  color: #FFFFFF;
line-height: 14px;
font-size:14px ;
border-bottom: solid 1px;
position: relative;
    top: 12px;
}
.expBox{
  text-align: left;
  background: rgba(255,255,255,0.2);
    border-radius: 8px;
    width: 320px;
    padding: 10px 12px;
  margin: auto;
  color: #fff;
    margin-top: 60px;
    font-size: 12px;
    line-height: 21px;
}
.chgbox {
  display: flex;
  position: relative;
  top:30px;
  width: 350px;
  margin: auto;
}
.chgbox ul{
  display: flex;
}
.chgbox li{
  display: inline-block;
  width: 170px;
  text-align: center;
 
}
.active {
  color:#fff !important;
  background-color: #e6a23c !important;
}
.chgbtn{
  padding: 5px 15px;
  border-radius: 10px;
  width: 157px;
    background-color: #a9a9a961;
    padding: 6px 15px;
    border-radius: 20px;
    font-size: 16px;
    color: #d9d3d3;
}
</style>
